"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfListLevel = void 0;
var string_helper_1 = require("../../../../core/formats/utils/string-helper");
var character_properties_1 = require("../../../../core/model/character/character-properties");
var list_level_properties_1 = require("../../../../core/model/numbering-lists/list-level-properties");
var paragraph_properties_1 = require("../../../../core/model/paragraph/paragraph-properties");
var rich_utils_1 = require("../../../../core/model/rich-utils");
var list_level_display_text_helper_1 = require("../../../utils/list-level-display-text-helper");
var RtfListLevel = (function () {
    function RtfListLevel() {
        this.text = "";
        this.numbers = "";
        this.initialize();
        this.listLevelProperties.start = 1;
        this.listLevelProperties.separator = rich_utils_1.RichUtils.specialCharacters.TabMark;
        this.listLevelProperties.displayFormatString = "{0}.";
        this.listLevelProperties.relativeRestartLevel = 0;
    }
    RtfListLevel.prototype.initialize = function () {
        this.characterProperties = new character_properties_1.MaskedCharacterProperties();
        this.paragraphProperties = new paragraph_properties_1.MaskedParagraphProperties();
        this.listLevelProperties = new list_level_properties_1.ListLevelProperties();
    };
    RtfListLevel.prototype.createDisplayFormatString = function () {
        var placeholderIndices = this.createPlaceholderIndices();
        if (this.text.length == 0)
            return '';
        else
            return string_helper_1.StringHelper.removeSpecialSymbols(this.createDisplayFormatStringCore(placeholderIndices));
    };
    RtfListLevel.prototype.createPlaceholderIndices = function () {
        var count = Math.min(9, this.numbers.length);
        var result = new Array();
        result.push(0);
        for (var i = 0; i < count; i++)
            if (this.numbers.charCodeAt(i) <= this.text.length)
                result.push(this.numbers.charCodeAt(i));
        result.push(this.text.length);
        return result;
    };
    RtfListLevel.prototype.createDisplayFormatStringCore = function (placeholderIndices) {
        return list_level_display_text_helper_1.ListLevelDisplayTextHelper.createDisplayFormatStringCore(placeholderIndices, this.text);
    };
    return RtfListLevel;
}());
exports.RtfListLevel = RtfListLevel;
